import { getEnumObject } from '@/common/utilities.js';

export const pendingRequestsSources = {
  CP: 2,
  MMS: 1,
};

export default getEnumObject(pendingRequestsSources);
